import React from 'react';
import {
  CalendarDays,
  Clock,
  Languages,
  LayoutDashboard,
  MessageCircle,
  Printer,
  Truck,
  UtensilsCrossed
} from 'lucide-react';

const icons = [
  UtensilsCrossed,
  MessageCircle,
  CalendarDays,
  LayoutDashboard,
  Truck,
  Printer,
  Clock,
  Languages
];

export function WsjPedidosUnifiedFeaturesSection({ copy }) {
  return (
    <section id="wsj-pedidos-unified" className="max-w-6xl mx-auto mb-20 sm:mb-28 scroll-mt-28">
      <div className="text-center mb-10 sm:mb-12">
        <h2 className="text-2xl sm:text-4xl font-black text-white tracking-tight">{copy.sectionUnifiedTitle}</h2>
        <p className="text-white/50 mt-3 max-w-2xl mx-auto font-light leading-relaxed">{copy.sectionUnifiedLead}</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
        {copy.unifiedBlocks.map((block, i) => {
          const Icon = icons[i] || UtensilsCrossed;
          return (
            <div
              key={block.title}
              className="group relative rounded-2xl border border-white/[0.08] bg-gradient-to-b from-white/[0.05] to-slate-950/30 p-5 sm:p-6 transition-all duration-300 hover:border-amber-500/30 hover:shadow-[0_20px_50px_-28px_rgba(212,165,116,0.2)] hover:-translate-y-0.5"
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-500/20 to-transparent border border-amber-500/25 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform duration-300">
                <Icon className="w-6 h-6 text-amber-400/95" aria-hidden />
              </div>
              <h3 className="text-sm sm:text-base font-bold text-white mb-2 tracking-tight">{block.title}</h3>
              <p className="text-xs sm:text-sm text-white/45 leading-relaxed font-light break-words min-w-0">{block.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
